import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["icon", "iconTheme", "className", "children"];
import * as React from 'react';
import clsx from 'clsx';
import { getElementChildren } from '../../../utils';
import { Base } from '../../Base';
import { ListItem } from '../ListItem';
var styles = {
  "root": "UnorderedList-root_xOVC1",
  "item": "UnorderedList-item_5TBPh"
};
function UnorderedList(_ref) {
  var icon = _ref.icon,
    iconTheme = _ref.iconTheme,
    className = _ref.className,
    children = _ref.children,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var hasIcon = !!icon;
  var hasGap = typeof extraProps.gap === 'string';
  var elements = getElementChildren(children);

  // @TODO: Filter for React Elements.
  var items = React.Children.map(elements, function (child) {
    if (!hasIcon) {
      hasIcon = typeof child.props.icon === 'string';
    }
    return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({
      icon: icon,
      iconTheme: iconTheme
    }, child.props), {}, {
      // Positioned last so it don't get overriden by the above spread.
      className: clsx(child.props.className, styles.item)
    }));
  });
  var theme = hasIcon ? {
    margin: 'none',
    padding: 'none',
    listStyleType: 'none'
  } : {
    margin: 'none',
    paddingLeft: 'small'
  };
  return /*#__PURE__*/React.createElement(Base, _extends({
    tagName: "ul",
    grid: hasGap,
    className: clsx(styles.root, className)
  }, theme, extraProps), items);
}
export { UnorderedList };